<div
  [formGroup]="priceLogicForm"
  class="border border-light-gray rounded-1 p-3">
  <div class="container-fluid px-0">
    <!-- Price Logic Selection -->
    <div class="row mb-4">
      <div class="col-md-12">
        <h6 class="mb-3">Select Price Logic</h6>
        <ng-select
          formControlName="selectedPriceLogic"
          class="currency-select ms-0"
          placeholder="Select a pricing logic"
          (change)="updateSelectedPriceLogic($event)"
          [loading]="isLoadingPriceLogics">
          <ng-option
            *ngFor="let priceLogic of priceLogics"
            [value]="priceLogic"
            class="border-0">
            {{ priceLogic.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>

    <!-- Formula Selection -->
    <div class="row mb-4" *ngIf="selectedPriceLogic">
      <div class="col-md-12">
        <h6 class="mb-3">Select Formula (Optional)</h6>
        <ng-select
          formControlName="selectedFormula"
          class="ms-0"
          placeholder="Select a specific formula to use"
          (change)="updateSelectedFormula($event)"
          [loading]="isLoadingPriceFormulas">
          <ng-option [value]="null" class="border-0"
            >None (Use logic conditions)</ng-option
          >
          <ng-option
            *ngFor="let formula of priceFormulas"
            [value]="formula"
            class="border-0">
            {{ formula.name }}
          </ng-option>
        </ng-select>
        <small class="form-text text-muted"
          >Selecting a specific formula will override the regular condition
          evaluation in the price logic</small
        >
      </div>
    </div>

    <!-- Currency Selection -->
    <div class="row mb-4" *ngIf="selectedPriceLogic">
      <div class="col-md-12">
        <label class="form-label mb-2">Service Currency</label>
        <ng-select
          formControlName="serviceCurrency"
          [items]="serviceCurrenciesBuffer"
          [virtualScroll]="true"
          [loading]="isLoadingServiceCurrencies"
          bindLabel="code"
          bindValue="code"
          placeholder="Choose the service currency"
          (scrollToEnd)="fetchServiceCurrencies()"
          (search)="onSearchServiceCurrency($event)">
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm">
            <strong>{{ item.code }}</strong>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Price Logic Parameters Mapping -->
    <div
      class="row"
      *ngIf="selectedPriceLogic && priceLogicParameters.length > 0">
      <div class="col-md-12">
        <div class="border border-light-gray rounded-1 p-3 mt-2">
          <h6 class="mb-3">Map Price Logic Parameters to Form Fields</h6>
          <div
            class="row mb-3"
            *ngFor="let param of priceLogicParameters; let paramIndex = index">
            <div class="col-md-4">
              <label class="form-label mb-1">{{ param.name }}</label>
              <small class="form-text text-muted d-block mb-2">{{
                param.paramType
              }}</small>
            </div>
            <div class="col-md-8">
              <!-- Parameter Mapping Type Selection -->
              <div class="mb-2">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [id]="'mapTypeField_' + param.code"
                    [value]="'field'"
                    [formControlName]="'mapType_' + param.code" />
                  <label
                    class="form-check-label"
                    [for]="'mapTypeField_' + param.code"
                    >Map to Form Field</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [id]="'mapTypeConstant_' + param.code"
                    [value]="'constant'"
                    [formControlName]="'mapType_' + param.code" />
                  <label
                    class="form-check-label"
                    [for]="'mapTypeConstant_' + param.code"
                    >Use Constant</label
                  >
                </div>
              </div>

              <!-- Field Mapping Dropdown -->
              <ng-container
                *ngIf="getParameterMappingType(param.code) === 'field'">
                <ng-select
                  class="currency-select w-100"
                  [formControlName]="'paramField_' + param.code"
                  [placeholder]="'Select form field for ' + param.name">
                  <ng-option
                    *ngFor="let field of getCompatibleFields(param)"
                    [value]="field.key">
                    {{ field?.props?.label ?? field?.label }}
                  </ng-option>
                </ng-select>
                <small
                  *ngIf="getCompatibleFields(param).length === 0"
                  class="text-danger mt-1 d-block">
                  No compatible fields found for this parameter type.
                </small>
              </ng-container>

              <!-- Constant Value Input -->
              <ng-container
                *ngIf="getParameterMappingType(param.code) === 'constant'">
                <ng-container [ngSwitch]="param.paramType.toLowerCase()">
                  <!-- Number parameter -->
                  <input
                    *ngSwitchCase="'number'"
                    type="number"
                    class="form-control"
                    [formControlName]="'paramConst_' + param.code"
                    [placeholder]="'Enter constant value for ' + param.name" />

                  <!-- Text parameter -->
                  <input
                    *ngSwitchCase="'text'"
                    type="text"
                    class="form-control"
                    [formControlName]="'paramConst_' + param.code"
                    [placeholder]="'Enter constant value for ' + param.name" />

                  <!-- Boolean parameter -->
                  <div *ngSwitchCase="'boolean'" class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [formControlName]="'paramConst_' + param.code"
                      [id]="'paramConst_' + param.code" />
                    <label
                      class="form-check-label"
                      [for]="'paramConst_' + param.code"
                      >Enable</label
                    >
                  </div>

                  <!-- Default case -->
                  <input
                    *ngSwitchDefault
                    type="text"
                    class="form-control"
                    [formControlName]="'paramConst_' + param.code"
                    [placeholder]="'Enter constant value for ' + param.name" />
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
